import { createSimpleFunctional } from '@/util'

export default createSimpleFunctional('v-banner-text')
